//#region libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedFlight, selectFlightStatus, getFlightInformation, selectFlightInformation, selectFlightAverage, selectFlightError } from '_redux/slices/flights/flight-information';


// custom components
import { Card, CustomSpinner } from '_atoms';
import { FlightAveragesModal } from '_molecules';

// icons
import { MdError } from "react-icons/md";

// tremor
import { Title as TremorTitle, Flex, List, ListItem, Block, Text, Metric, Bold } from '@tremor/react';
import { formatTimestamp } from '_utils/date-time-functions';
//#endregion

function splitFlightNumber(flightNumber) {
    if (flightNumber.length < 3) {
        throw new Error('Invalid flight number format');
    }

    const carrierCode = flightNumber.slice(0, 2);
    const flightNum = flightNumber.slice(2);

    return {
        carrierCode: carrierCode,
        flightNum: flightNum
    };
}

// takes a flight number and departure date and returns the flight information card
const FlightInformationCard = (props) => {

    //#region redux
    const dispatch = useDispatch();

    const flightDetails = useSelector(selectFlightInformation);
    const selectedFlight = useSelector(selectSelectedFlight);
    const flightAverage = useSelector(selectFlightAverage);
    const status = useSelector(selectFlightStatus);
    const error = useSelector(selectFlightError);
    //#endregion

    //#region local states
    const [carrierCode, setCarrierCode] = useState('');
    const [displayFlightNumber, setDisplayFlightNumber] = useState('');
    const [origin, setOrigin] = useState('');
    const [departureTime, setDepartureTime] = useState('');
    const [arrivalTime, setArrivalTime] = useState('');
    const [destination, setDestination] = useState('');
    const [selectedMethod, setSelectedMethod] = useState('None');
    //#endregion

    //#region useEffect
    useEffect(() => {
        if (flightDetails && flightDetails.origin && flightDetails.destination && flightDetails.flightNumber && flightDetails.carrierCode && flightDetails.departureTime) {
            setDisplayFlightNumber(flightDetails.flightNumber);
            setOrigin(flightDetails.origin)
            setDestination(flightDetails.destination);
            setCarrierCode(flightDetails.carrierCode);
            setDepartureTime(flightDetails.departureTime);
            setArrivalTime(flightDetails.arrivalTime)
        }
        else {
            console.log('issue with flight details...')
        }
    }, [flightDetails]);

    useEffect(() => {
        if (flightAverage && flightAverage.forecastMethod) {
            if (flightAverage.forecastMethod != undefined) {
                if (flightAverage.forecastMethod == "2_WEEK_SAME_DAY") { setSelectedMethod('2 Week Average (Same Day)') }
                if (flightAverage.forecastMethod == "2_WEEK") { setSelectedMethod('2 Week Average (All Flights)') }
                if (flightAverage.forecastMethod == "2_WEEK_ROUTE") { setSelectedMethod('2 Week Route Average') }
                if (flightAverage.forecastMethod == "2_WEEK_NO_SHOW") { setSelectedMethod('2 Week No Show Bookings Average') }
                if (flightAverage.forecastMethod == "2_WEEK_NO_SHOW_SAME_DAY") { setSelectedMethod('2 Week No Show Bookings Average (Same Day)') }
            }
        }
    }, [flightAverage]);

    // refresh booking info on render
    useEffect(() => {
        if (selectedFlight && selectedFlight.flight && selectedFlight.date) {
            if (selectedFlight?.flight?.match(/^([a-zA-Z]+)(\d+)$/)) refreshFlightDetails();
        }
    }, []);
    //#endregion

    // gets flight details using departure date and flight number
    const refreshFlightDetails = () => {
        // split carrier code and flight number
        const split = splitFlightNumber(selectedFlight.flight);
        const carrierCode = split.carrierCode;
        const number = split.flightNum;

        // console.log('refreshing flight details...')

        dispatch(getFlightInformation({
            flightNumber: number,
            carrierCode: carrierCode,
            departureDate: selectedFlight.date
        }))
    }

    return (
        <Row>
            <Col xs={3}>
                <Card>
                    <div style={{ minHeight: '225px' }}>

                        {/* flight info */}
                        {status == 'loading' ? <CustomSpinner size={"large"} rowCenter={true} /> :
                            <>
                                <TremorTitle>Flight Information</TremorTitle>

                                <Metric>{origin + ' - ' + destination}</Metric>

                                {error ? <div style={{ display: 'flex' }}><MdError color={'red'} size={22} /><p style={{ color: 'red' }}>{error}</p></div> :
                                    <Block>
                                        <List>
                                            <ListItem>
                                                <Flex>
                                                    <Text truncate={true}>Flight Number</Text>
                                                    <Text><Bold>{carrierCode + displayFlightNumber}</Bold></Text>
                                                </Flex>
                                            </ListItem>

                                            <ListItem>
                                                <Flex>
                                                    <Text truncate={true}>Departure Date</Text>
                                                    <Text><Bold>{formatTimestamp(departureTime)}</Bold></Text>
                                                </Flex>
                                            </ListItem>

                                            <ListItem>
                                                <Flex>
                                                    <Text truncate={true}>Arrival Date</Text>
                                                    <Text><Bold>{formatTimestamp(arrivalTime)}</Bold></Text>
                                                </Flex>
                                            </ListItem>

                                            <ListItem>
                                                <Flex>
                                                    <Text truncate={true}>Preferred Averaging Method</Text>
                                                    <Text><Bold>{selectedMethod}</Bold></Text>
                                                </Flex>
                                            </ListItem>
                                        </List>
                                    </Block>
                                }
                            </>
                        }

                    </div>
                </Card>
            </Col>

            {/* flight forecast */}
            <Col>
                <Card>
                    <FlightAveragesModal clickedFlight={selectedFlight.flight} />
                </Card>
            </Col>
        </Row>
    );
};

export default FlightInformationCard;
